type SuffixHandlerOrRegExp = (((message: string) => string) | RegExp);

export interface KnownSentryError {
	readonly messages: Array<string>,
	readonly fingerprint: string,
	readonly suffix?: SuffixHandlerOrRegExp[];
}

export interface InternalInformationSentryError {
	readonly message: string;
	readonly fingerprint: string;
	readonly suffix?: SuffixHandlerOrRegExp[];
}

export const KNOWN_SENTRY_ERRORS: Array<KnownSentryError> = [
	{
		messages: [
			"Texture Error: frame does not fit inside the base Texture"
		],
		fingerprint: "texture-error-frame-does-not-fit-inside"
	},
	{
		messages: [
			"Cannot read property 'gain' of undefined",
			"Cannot read properties of undefined (reading 'gain')",
			"undefined is not an object (evaluating 'this._howlNode.gain",
			"can't access property \"gain\", this._howlNode is undefined"
		],
		fingerprint: "type-error-howler-cannot-read-gain"
	},
	{
		messages: [
			"(soundGainNode=sound.node).disconnect is not a function.",
			"(intermediate value)(intermediate value).disconnect is not a function",
			"soundGainNode.disconnect is not a function"
		],
		fingerprint: "type-error-howler-sounds-node-discconect-is-not-a-function"
	},
	{
		messages: [
			"NotAllowedError: play() failed because the user didn't interact with the document first",
			"NotAllowedError: play() can only be initiated by a user gesture"
		],
		fingerprint: "error-user-didnt-interact-with-document"
	},
	{
		messages: [
			"Can't remove messagePopup. It is not on the stack, neither as current state.",
			"Can't remove messagePopupBlocking. It is not on the stack, neither as current state."
		],
		fingerprint: "cant-clear-overwrite-error"
	},
	{
		messages: [
			"you can not have 2 same states",
		],
		fingerprint: "you-can-not-have-two-same-states",
		suffix: [
			/2 same states \((\w*)\)/i
		]
	},
	{
		messages: [
			"Failed to execute 'attachShader' on 'WebGLRenderingContext': parameter 2 is not of type 'WebGLShader'",
			"WebGLRenderingContext.attachShader: Argument 2 is not an object."

		],
		fingerprint: "attach-shader-error"
	},
	{
		messages: [
			"Failed to execute 'shaderSource' on 'WebGLRenderingContext': parameter 1 is not of type 'WebGLSh",
			"WebGLRenderingContext.shaderSource: Argument 1 is not an object."

		],
		fingerprint: "attach-shader-error"
	},
	{
		messages: [
			"Argument 1 ('program') to WebGLRenderingContext.getProgramParameter must be an instance of WebGL",
			"WebGLRenderingContext.getProgramParameter: Argument 1 is not an object."

		],
		fingerprint: "get-program-parameter-error"
	},
	{
		messages: [
			"errorMessage.toLowerCase is not a function",
			"toLowerCase is not a function"
		],
		fingerprint: "errorMessage-toLowerCase-error"
	},
	{
		messages: [
			"getRoot is not a function",
			"getRoot is not defined",
			"Can't find variable: getRoot"
		],
		fingerprint: "getRoot-error"
	},
];

// Errors sent to Sentry as 'handled', but hidden from player (do not show in Error box/modal)
export const ERRORS_MARKED_AS_HANDLED = [
	"Script error",
	"Possible side-effect"
];